import { render } from "./VehicleModelList.vue?vue&type=template&id=63ca04d8&scoped=true"
import script from "./VehicleModelList.vue?vue&type=script&lang=js"
export * from "./VehicleModelList.vue?vue&type=script&lang=js"

import "./VehicleModelList.vue?vue&type=style&index=0&id=63ca04d8&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ca04d8"]])

export default __exports__